import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { IconPencil } from '@calendly/ui/components/glyphs/IconPencil'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import { useCallback } from 'react'

import { useAvailabilitySidePanelActions } from '../available_hours/components/availability_side_panel'

export const V4EditAvailabilityButton = ({ formPath }) => {
  const { openAvailabilitySidePanel } = useAvailabilitySidePanelActions()

  const handleClick = useCallback(() => {
    openAvailabilitySidePanel({ formPath, format: 'list' })
  }, [
    formPath,
    openAvailabilitySidePanel,
  ])

  return (
    <Button
      data-testid="v4-edit-availability-button"
      decoration="ghost"
      onClick={handleClick}
      size="small"
    >
      <UiIcon icon={IconPencil} size="small" />
      {I18n.t('publisher.event_type_editor_crud.availability.edit_availability')}
    </Button>
  )
}
